import clsx from 'clsx';
import Paragraph from 'components/text/Paragraph';
import { AlertCircle, LucideIcon } from 'lucide-react';
import * as React from 'react';

interface Props {
  error?: boolean;
  helperText: string;
  className?: string;
  Icon?: LucideIcon;
}

const HelperText: React.FC<Props> = props => {
  const { error, helperText, className, Icon } = props;
  return (
    <Paragraph
      color="subtle"
      className={clsx('text-xs flex gap-3', error && '!text-error-main', className)}
    >
      <span>{Icon ? <Icon size={16} /> : <AlertCircle size={16} />}</span>
      {helperText}
    </Paragraph>
  );
};

HelperText.displayName = 'HelperText';
export default HelperText;
